import { styled } from "@mui/material/styles";

import { accessibleInteractiveColors } from "@/theme/accessibility";

export const HeaderStyled = styled("div")(({ theme }) => ({
  "& .Navbar": {
    background: " #EAF6FF",
    boxSizing: "border-box",
    padding: "8px 32px",
    height: "68px",
    color: accessibleInteractiveColors.navigationBlue,
    width: "100%",
    zIndex: "999",
    fontFamily: "Poppins",
  },
  "& .HeaderOption": {
    padding: "0 !important",
    width: "fit-content",
  },
  "& .logo": {
    flexShrink: 0,
  },
  "& .optionData": {
    width: "100%",
    padding: "5px",
    lineHeight: `${14 * 1.4}px`,
    textTransform: "capitalize",
  },
  "& .optionData a": {
    width: "100%",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#651F70",
    fontFamily: "Poppins",
    position: "relative",
    whiteSpace: "nowrap",
    textTransform: "capitalize",
  },
  "& .help": {
    margin: " 0px 16px",
    fontSize: " 14px",
    // color: "#000",
    // background: "#EAF6FF",
    padding: "3px 0px",
    borderRadius: "5px",
  },

  "& .subheader ": {
    background: "#FFF",
    width: "100%",
    height: "33px",
    padding: "0px",
  },
  "& .web-header-layout": {
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
    alignItems: "center",
  },
  "& .nav": {
    minHeight: "52px !important",
  },
  "& .headerButton": {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
    textTransform: "capitalize",
    whiteSpace: "nowrap",
  },
  "& .bodymap-back": {
    color: "#3E73A4",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    justifyContent: "flex-start",
    fontWeight: 500,
    fontSize: 14,
    cursor: "pointer",
  },
  "& .helpSupport": {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  },
  "& .helpSupport svg": {
    transform: " rotate(270deg)",
  },
  "& .mainHeaderLayout": {
    width: "100%",
    maxWidth: "none",
    margin: 0,
    boxSizing: "border-box",
  },
  "& .mobile-header-layout": {
    display: "none",
  },
  "& .header-actions": {
    flexShrink: 0,
    minWidth: 0,
  },
  [theme.breakpoints.between("md", "lg")]: {
    "& .mainHeaderLayout": {
      width: "100%",
      maxWidth: "none",
      margin: 0,
    },
    "& .web-header-layout": {
      gap: "2px",
      flexWrap: "nowrap",
    },
    "a.logo svg": {
      width: "111px",
    },
    "& .headerButton div": {
      fontSize: "12.5px",
      padding: "2px 4px",
    },
    ".Navbar": {
      padding: "3px 12px",
    },
    ".headerButton": {
      margin: "0",
    },
    "& .nav": {
      margin: "0px 10px 7px 0px",
    },
  },
  // Keep the drawer header available below the same breakpoint as page grids.
  [theme.breakpoints.down("md")]: {
    "& .web-header-layout": {
      display: "none",
    },
    "& .mobile-header-layout": {
      display: "block",
    },
    "& .mainHeaderLayout": {
      width: "100%",
      maxWidth: "none",
      margin: 0,
    },
    "& .Navbar": {
      boxSizing: "border-box",
      paddingInline: "8px",
    },
    "& .nav": {
      width: "100%",
      margin: "0 !important",
    },
    "& .header-actions": {
      gap: "10px",
    },
    "& .logo": {
      display: "none",
    },
  },
}));
